import React, { useState } from 'react';
import Carousel from 'react-material-ui-carousel';
import { styled } from '@mui/system';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Stack, Typography, Box } from '@mui/material';
import profile_carousel_image_1 from '../../../assests/images/profile_carousel_image_1.svg';
import profile_carousel_image_2 from '../../../assests/images/profile_carousel_image_2.svg';
import profile_carousel_image_3 from '../../../assests/images/profile_carousel_image_3.svg';

const CustomIndicator = styled('div')(({ active }) => ({
  width: active ? '30px' : '10px',
  height: active ? '12px' : '10px',
  borderRadius: active ? '20px' : '50%',
  backgroundColor: active ? '#005CBC' : '#D0D0D0',
  margin: '0 5px',
  cursor: 'pointer',
  justifyContent: 'left'
}));

const ProfileCarousel = () => {
  let items = [
    {
      title: 'Analyze',
      description: 'Explore the full range of data analysis capabilities with PO.',
      image: profile_carousel_image_1
    },
    {
      title: 'Vote',
      description: 'Share your opinion on whether to de-list a specific product or retain it.',
      image: profile_carousel_image_2
    },
    {
      title: 'Decide',
      description: 'Make a better decision on which products should remain in the market.',
      image: profile_carousel_image_3
    }
  ];
  const [activeIndex, setActiveIndex] = useState(0);

  const handleChange = (index) => {
    setActiveIndex(index);
  };

  return (
    <div>
      <Carousel
        index={activeIndex}
        onChange={(index) => handleChange(index)}
        animation="slide"
        indicators={false}
        fullHeightHover={false} // We want the nav buttons wrapper to only be as big as the button element is
        navButtonsProps={{
          // Change the colors and radius of the actual buttons. THIS STYLES BOTH BUTTONS
          style: {
            color: 'cornflowerblue',
            borderRadius: 0,
            background: 'none'
          }
        }}
        navButtonsWrapperProps={{
          // Move the buttons to the bottom. Unsetting top here to override default style.
          style: {
            bottom: '0',
            top: '40%'
          }
        }}
        NextIcon={<ArrowForwardIosIcon data-testid="NextIcon" />}
        PrevIcon={<ArrowBackIosIcon data-testid="PrevIcon" />}
        swipe={true}>
        {items.map((item, i) => (
          <Item key={`${i + 1}`} item={item} />
        ))}
      </Carousel>
      <Indicators items={items} activeIndex={activeIndex} handleChange={handleChange} />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '190px',
          width: '100%'
        }}>
        <img src={items[activeIndex].image} alt={items[activeIndex].title} height="100%" />
      </Box>
    </div>
  );
};
const Item = ({ item }) => {
  return (
    <Stack
      key={item.title}
      sx={{
        justifyContent: 'space-between',
        maxWidth: '300px',
        backgroundColor: '#FBFCFE'
      }}>
      <Stack direction="column" gap="12px">
        <Stack gap={1} sx={{ color: '#616161', fontWeight: 400 }}>
          <Typography sx={{ fontSize: 32, lineHeight: '38.73px' }}>{item.title}</Typography>
          <Typography sx={{ fontSize: 14, lineHeight: '17px' }}>{item.description}</Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
const Indicators = ({ items, activeIndex, handleChange }) => {
  return (
    <div
      style={{ display: 'flex', justifyContent: 'left', marginTop: '10px', marginBottom: '10px' }}>
      {items.map((_, index) => (
        <CustomIndicator
          key={`${index + 1}`}
          active={activeIndex === index}
          onClick={() => handleChange(index)}
        />
      ))}
    </div>
  );
};

export default ProfileCarousel;
